<template>
  <div class="main">
    <div class="container projects-container">
      <div class="header">
        <router-link :to="{name: 'home'}">
          <el-button type="primary" class="back-button" icon="el-icon-back"></el-button>
        </router-link>
      </div>
      <div class="content">
        <h2>Wichtelgruppen verwalten</h2>
        <el-row :span="24" v-for="(project, index) in this.tableData" :key="index" :offset="index > 0 ? 2 : 0">
          <el-col>
            <el-card>
              <div>
                <b><span>{{project.name}}</span> <span v-if=isAdmin(project)> (Admin)</span></b>
                <p class="small-space-top">{{project.users.length}} Benutzer</p>
                <p style="color: red;" v-if="project.finished">Abgeschlossen</p>
                <p style="color: green;" v-else>Läuft</p>
                <div v-if="isAdmin(project)" class="bottom">
                  <router-link :to="{name: 'project', params: { id: project.id }}">
                    <el-button type="primary" round class="button">Bearbeiten</el-button>
                  </router-link>
                  <el-button type="danger" round class="button">Löschen</el-button>
                </div>
                <div v-else class="bottom">
                  <el-button type="primary" @click="showMembers(project)" round>Mitglieder anzeigen</el-button>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-dialog v-if="selectedProject" title="Benutzer in der Gruppe" :visible.sync="userDialogVisible" center>
      <div class="grid">
        <el-card v-for="(user, index) in selectedProject.users" :key="index">
          <div class="user-card">
            <div class="card-content">
              <span>{{user.firstname}} {{user.lastname}}</span><br>
            </div>
          </div>
        </el-card>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="userDialogVisible = false">OK</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ProjectService from "../services/ProjectService.js";

export default {
  name: "ManageProjects",
  data() {
    return {
      tableData: [],
      userProjects: null,
      userDialogVisible: false,
      selectedProject: null
    };
  },
  created() {
    const projects = ProjectService.getProjectsFromLocalStorage();

    if (projects && projects.length > 0) {
      this.userProjects = projects;

      const allKeys = projects.map(project => project.projectKey);
      ProjectService.getAllProjectsForUser(allKeys).then(allProjects => {
        this.tableData = allProjects;
      });
    }
  },
  methods: {
    isAdmin(project) {
      let userProjects = ProjectService.getProjectFromLocalStorage(
        project.encryptedKey
      );
      let isAdmin = false;
      userProjects.forEach(savedProject => {
        if (savedProject.role === "admin") {
          isAdmin = true;
        }
      });
      return isAdmin;
    },
    showMembers(project) {
      this.selectedProject = project;
      this.userDialogVisible = true;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.main {
  .projects-container {
    overflow-y: scroll;

    .el-row {
      width: 95%;
      height: 250px;
    }

    .el-col-24 {
      width: 100%;
      height: 100%;
      padding: 25px;

      .el-card {
        height: 100%;
        padding: 15px;
        position: relative;

        .bottom {
          position: absolute;
          bottom: 5px;
          left: 0px;
          width: 100%;

          .button:first-child {
            margin-right: 15px;
          }
        }
      }
    }
  }
}
</style>
